import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * The Documents tab body (SWOOP-254 US3), rendered inside the work-order page layout at
 * `/work-orders/$workOrderId/documents`. Permission / module gating is inherited from the layout route's
 * `beforeLoad`.
 */
export const Route = createFileRoute('/_authenticated/work-orders_/$workOrderId/documents')({
  component: lazyRouteComponent(() => import('&/features/work-orders/pages/work-order-documents-tab')),
  staticData: { titleKey: 'workOrderDocuments' },
});
